import React from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import TutorialBanner from '@assets/tutorial-banner.png';

import Step1Iphone from '@assets/step-1-iphone.png';
import Step2Iphone from '@assets/step-2-iphone.png';
import Step3Iphone from '@assets/step-3-iphone.png';
import Step4Iphone from '@assets/step-4-iphone.png';

import Step1Android from '@assets/step-1-android.png';
import Step2Android from '@assets/step-2-android.png';
import Step3Android from '@assets/step-3-android.png';
import Step4Android from '@assets/step-4-android.png';
import Step5Android from '@assets/step-5-android.png';
import Step6Android from '@assets/step-6-android.png';

import stzOuzeLogo from '@assets/stz-ouze-logo.png';

interface ITutorialProps {
    contentType: any;
    isMobile: boolean;
}

export const Tutorial: React.FC<ITutorialProps> = ({ contentType, isMobile }) => {
    const linkStyle = {
        color: '#E400E4',
        fontWeight: 600
    };
    const imgStyleMob = {
        width: '100%',
        margin: '30px auto',
        maxWidth: '337px',
        display: 'block'
    };
    const typographyStyleMob: React.CSSProperties = {
        textAlign: 'center',
        fontSize: '17px',
        lineHeight: 1.5
    };
    const typographyStyleDesk: React.CSSProperties = {
        textAlign: 'center',
        fontSize: '37px',
        lineHeight: 1.5,
        margin: '0 auto',
        maxWidth: '671px'
    };

    const scrollToStep = (step: number) => {
        const stepElement = document.getElementById(`step-${step}`);
        if (stepElement) {
            stepElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <Grid container rowSpacing={2} columnSpacing={2} px={2}>
            <Grid item xs={12}>
                <img srcSet={TutorialBanner} src={TutorialBanner} alt="Novo app Ouze" loading="lazy" style={{ width: 'calc(100% + 32px)', marginLeft: '-16px', marginRight: '-16px' }} />
                <Typography component="p" style={isMobile ? typographyStyleMob : typographyStyleDesk}>
                    Veja abaixo como baixar e testar o aplicativo no seu{' '}
                    <Typography component="span" style={{ ...(isMobile ? typographyStyleMob : typographyStyleDesk), fontWeight: 600, textTransform: 'capitalize' }}>
                        {contentType}
                    </Typography>
                    , é simples!
                </Typography>
            </Grid>
            <Divider sx={{ width: '70%', margin: '30px auto 14px auto' }} />
            <Grid id="step-1" item xs={12} onClick={() => scrollToStep(2)}>
                {contentType === 'iphone' && (
                    <Typography component="p" style={isMobile ? typographyStyleMob : typographyStyleDesk}>
                        1. Você deverá fazer o download do{' '}
                        <a href="https://apps.apple.com/us/app/testflight/id899247664" target="_blank" rel="noreferrer" style={linkStyle}>
                            TestFlight
                        </a>{' '}
                        através da App Store;
                    </Typography>
                )}
                {contentType === 'android' && (
                    <Typography component="p" style={isMobile ? typographyStyleMob : typographyStyleDesk}>
                        1. Busque o app{' '}
                        <a href="https://play.google.com/store/apps/details?id=br.com.calcard.android.app&hl=pt_BR&gl=US&pli=1" target="_blank" rel="noreferrer" style={linkStyle}>
                            Calcard Ouze
                        </a>{' '}
                        na Play Store e acesse sua página
                    </Typography>
                )}
            </Grid>
            <Grid item xs={6}>
                {contentType === 'iphone' && <img srcSet={Step1Iphone} src={Step1Iphone} alt="Tutorial iPhone - etapa 1" loading="lazy" style={imgStyleMob} />}
                {contentType === 'android' && <img srcSet={Step1Android} src={Step1Android} alt="Tutorial Android - etapa 1" loading="lazy" style={imgStyleMob} />}
            </Grid>
            <Grid item xs={6}>
                {contentType === 'iphone' && <img srcSet={Step2Iphone} src={Step2Iphone} alt="Tutorial iPhone - etapa 2" loading="lazy" style={imgStyleMob} />}
                {contentType === 'android' && <img srcSet={Step2Android} src={Step2Android} alt="Tutorial Android - etapa 2" loading="lazy" style={imgStyleMob} />}
            </Grid>
            <Grid id="step-2" item xs={12} onClick={() => scrollToStep(3)}>
                {contentType === 'iphone' && (
                    <Typography component="p" style={isMobile ? typographyStyleMob : typographyStyleDesk}>
                        2. Depois basta você acessar{' '}
                        <a href="https://testflight.apple.com/join/vJ3vI56M" target="_blank" rel="noreferrer" style={linkStyle}>
                            esse link
                        </a>{' '}
                        e começar a testar o novo app{' '}
                        <Typography component="span" style={{ ...(isMobile ? typographyStyleMob : typographyStyleDesk), fontWeight: 600 }}>
                            Ouze
                        </Typography>
                        !
                    </Typography>
                )}
                {contentType === 'android' && (
                    <Typography component="p" style={isMobile ? typographyStyleMob : typographyStyleDesk}>
                        2. Depois basta você clicar para participar do{' '}
                        <Typography component="span" style={{ ...(isMobile ? typographyStyleMob : typographyStyleDesk), fontWeight: 600 }}>
                            programa Beta
                        </Typography>{' '}
                        e confirmar.
                    </Typography>
                )}
            </Grid>
            <Grid item xs={6}>
                {contentType === 'iphone' && <img srcSet={Step3Iphone} src={Step3Iphone} alt="Tutorial iPhone - etapa 3" loading="lazy" style={imgStyleMob} />}
                {contentType === 'android' && (
                    <img srcSet={Step3Android} src={Step3Android} alt="Tutorial Android - etapa 3" loading="lazy" style={{ ...imgStyleMob, marginTop: isMobile ? '10px' : '-14px' }} />
                )}
            </Grid>
            <Grid item xs={6}>
                {contentType === 'iphone' && <img srcSet={Step4Iphone} src={Step4Iphone} alt="Tutorial iPhone - etapa 4" loading="lazy" style={imgStyleMob} />}
                {contentType === 'android' && <img srcSet={Step4Android} src={Step4Android} alt="Tutorial Android - etapa 4" loading="lazy" style={imgStyleMob} />}
            </Grid>
            <Grid id="step-3" item xs={12} onClick={() => (contentType === 'android' ? scrollToStep(4) : '')}>
                {contentType === 'iphone' && (
                    <Typography component="p" style={isMobile ? typographyStyleMob : typographyStyleDesk}>
                        3. Para finalizar, compartilhem erros ou sugestões{' '}
                        <a href="https://forms.gle/igd4aVYPHd6tMb7x7" target="_blank" rel="noreferrer" style={linkStyle}>
                            nesse formulário
                        </a>
                        .
                    </Typography>
                )}
                {contentType === 'android' && (
                    <Typography component="p" style={isMobile ? typographyStyleMob : typographyStyleDesk}>
                        3. Atualizando a página você verá que o nome do app estará{' '}
                        <Typography component="span" style={{ ...(isMobile ? typographyStyleMob : typographyStyleDesk), fontWeight: 600 }}>
                            diferente
                        </Typography>
                        . Pronto, agora é só{' '}
                        <Typography component="span" style={{ ...(isMobile ? typographyStyleMob : typographyStyleDesk), fontWeight: 600 }}>
                            atualizar o app
                        </Typography>
                        !
                    </Typography>
                )}
            </Grid>
            {contentType === 'android' && (
                <>
                    <Grid item xs={6}>
                        <img srcSet={Step5Android} src={Step5Android} alt="Tutorial Android - etapa 5" loading="lazy" style={imgStyleMob} />
                    </Grid>
                    <Grid item xs={6}>
                        <img srcSet={Step6Android} src={Step6Android} alt="Tutorial Android - etapa 6" loading="lazy" style={imgStyleMob} />
                    </Grid>
                    <Grid id="step-4" item xs={12}>
                        {contentType === 'android' && (
                            <Typography component="p" style={isMobile ? typographyStyleMob : typographyStyleDesk}>
                                4. Para finalizar, compartilhem erros ou sugestões{' '}
                                <a href="https://forms.gle/igd4aVYPHd6tMb7x7" target="_blank" rel="noreferrer" style={linkStyle}>
                                    nesse formulário
                                </a>
                                .
                            </Typography>
                        )}
                    </Grid>
                </>
            )}
            <Divider sx={{ width: '70%', margin: '30px auto 14px auto' }} />
            <Grid item xs={12}>
                <Typography component="p" style={isMobile ? typographyStyleMob : typographyStyleDesk}>
                    Utilizem muito o novo app{' '}
                    <Typography component="span" style={{ ...(isMobile ? typographyStyleMob : typographyStyleDesk), fontWeight: 600, textTransform: 'capitalize' }}>
                        Ouze
                    </Typography>{' '}
                    e nos ajudem a manter uma experiência incrível para nossos clientes.
                </Typography>
                <Typography component="p" style={{ ...(isMobile ? typographyStyleMob : typographyStyleDesk), fontStyle: 'italic', margin: '30px auto' }}>
                    #tamojunto
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <img srcSet={stzOuzeLogo} src={stzOuzeLogo} alt="STZ & Ouze" loading="lazy" style={{ display: 'block', width: '50%', maxWidth: '257px', margin: '0 auto 30px auto' }} />
            </Grid>
        </Grid>
    );
};
